import { render, staticRenderFns } from "./AuctionTabs.vue?vue&type=template&id=2d630b80&scoped=true&"
import script from "./AuctionTabs.vue?vue&type=script&lang=js&"
export * from "./AuctionTabs.vue?vue&type=script&lang=js&"
import style0 from "./AuctionTabs.vue?vue&type=style&index=0&id=2d630b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d630b80",
  null
  
)

export default component.exports